import { render, staticRenderFns } from "./PolicyManage.vue?vue&type=template&id=00b27cc5&scoped=true"
import script from "./PolicyManage.vue?vue&type=script&lang=js"
export * from "./PolicyManage.vue?vue&type=script&lang=js"
import style0 from "./PolicyManage.vue?vue&type=style&index=0&id=00b27cc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b27cc5",
  null
  
)

export default component.exports